<template>
  <div class="white_background full-height">
    <div class="wrapped-page-container manage-chapter-studio">
      <v-layout row wrap justify-space-between>
        <v-flex xs12 sm6>
          <div class="manage-chapter-studio__title">{{manageChapterStudioConstant.PAGE_TITLE}}</div>
          <div class="manage-chapter-studio__subtitle">{{manageChapterStudioConstant.PAGE_SUBTITLE}}</div>
          <div v-if="manageChapterStudioBreadcrumbs && manageChapterStudioBreadcrumbs.length > 1"
               class="manage-chapter-studio__breadcrumb">
            <ypo-breadcrumb :breadcrumb-list="manageChapterStudioBreadcrumbs"></ypo-breadcrumb>
          </div>
        </v-flex>
        <v-flex class="text-right" xs12 sm6>
          <v-btn class="primary_btn manage-chapter-studio__create-btn mt-3" @click="handleCreateAnnouncement">
            <i class="fa-solid fa-circle-plus"></i>
            <span class="ml-2">{{manageChapterStudioConstant.CREATE_ACTION_BUTTON_LABEL}}</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="announcements-list__wrapper">
        <manage-announcement-card v-if="allAnnouncements.length" :allChapterStudioAnnouncements="allAnnouncements"/>
        <status-overlay :action="fetchingAnnouncementsLoadingAction" content-height="100px"></status-overlay>
      </div>
      <div v-if="allPastAnnouncements.length" class="announcements-list__past_announcements">
        <h2>{{manageChapterStudioConstant.PAST_ANNOUNCEMENT}}</h2>
        <div class="announcements-list__past_announcements--main inner-scrollbar">
          <manage-announcement-card :allChapterStudioAnnouncements="allPastAnnouncements"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { storeGetters } from "@/store/storeGetters.constant";
import { storeAction } from "@/store/storeActions.constant";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay.vue";
import { manageChapterStudioConstant } from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import YpoBreadcrumb from "@/components/YpoBreadcrumb/YpoBreadcrumb.vue";
import { routerNames } from "@/components/appCommon.constants";
import ManageAnnouncementCard from "@/components/ChapterStudioPageManage/ManageAnnouncementCard.vue";

export default {
  name: 'ManageChapterStudio',
  components: { YpoBreadcrumb, StatusOverlay, ManageAnnouncementCard },
  data() {
    return {
      manageChapterStudioConstant,
    };
  },
  props: {},
  async created() {
    await this.getAllChapterStudioAnnouncements();
    await this.getPastChapterStudioAnnouncements();
  },
  methods: {
    ...mapActions({
      getAllChapterStudioAnnouncements: `manageChapterStudio/${storeAction.getAllChapterStudioAnnouncements}`,
      getPastChapterStudioAnnouncements: `manageChapterStudio/${storeAction.getPastChapterStudioAnnouncements}`,
    }),
    ...mapMutations({
    }),
    handleCreateAnnouncement() {
      this.$router.push(`/${routerNames.CREATE_ANNOUNCEMENT}`);
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      manageChapterStudioAllAnnouncements: `manageChapterStudio/${storeGetters.manageChapterStudioAllAnnouncements}`,
      manageChapterStudioBreadcrumbs: `manageChapterStudio/${storeGetters.manageChapterStudioBreadcrumbs}`,
      manageChapterStudioPastAnnouncements: `manageChapterStudio/${storeGetters.manageChapterStudioPastAnnouncements}`,
    }),
    fetchingAnnouncementsLoadingAction() {
      return this.actions[storeAction.getAllChapterStudioAnnouncements];
    },
    allAnnouncements() {
       return this.manageChapterStudioAllAnnouncements ;
    },
    allPastAnnouncements() {
      return this.manageChapterStudioPastAnnouncements ;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.manage-chapter-studio {
  font-family: Roboto, 'sans-serif';
  padding-top: 10px;
  max-width: 100%;

  @include breakpointMin(sm) {
    max-width: 1221px;
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
    line-height: 42.19px;
    height: 42px;
    color: $ypo-blue;
  }

  &__subtitle {
    font-size: 28px;
    font-weight: 400;
    height: 33px;
    line-height: 32.81px;
    padding-top: 3px;
    color: $ypo-blue;
    margin-bottom: 10px;
  }

  &__breadcrumb {
    padding-top: 10px;
  }

  &__create-btn {
    font-family: sans-serif;
    background-color: $ypo-brand-blue !important;
    font-size: 16px;
    text-transform: capitalize;
    border-radius: 8px;
    height: 32px;
    width: 100%;
    margin-left: 0;
    padding-left: 15px;

    @include breakpointMin(sm) {
      width: 251px;
    }

    i {
      color: $white;
    }
  }

  .announcements-list {
    overflow: auto;
  
    &__wrapper {
    position: relative;
    margin-top: 18px;
  }

  &__past_announcements {
    border: 1px solid lightgray;

    .inner-scrollbar {
      margin-right: 0 !important;
    }

    h2 {
      background-color: $mild-grey; 
      color: white;  
      padding: 10px;  
      margin: 0;  
      width: 100%; 
      box-sizing: border-box; 
    }
  }
}
}
</style>

<style lang="scss">
@import "../../common/styles/_responsive.scss";

.manage-chapter-studio {
  &__create-btn {
    .v-btn__content {
      justify-content: flex-start;

      @include breakpointMin(sm) {
        justify-content: center;
      }
    }
  }
  .announcements-list {
    &__past_announcements {
      &--main {
        overflow-y: auto; 
        max-height: 575px;
        padding: 5px;
      }
    }
  }
}
</style>
